import { IKizMarkDTO, IKizMarkViewDTO } from "../../coreapi-dto/service/kizMark";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { IRequestEventHandler } from "../common";
import { BaseDirRequest } from "../dirs/baseDirRequest";

class KizMarkRequest extends BaseDirRequest<IKizMarkViewDTO, IKizMarkDTO>{
    
    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "kizMark", token, eventHandler)
    }    

    getView(body: IViewBody, callback?: (e) => void) {
        this.post<IViewWrapper<IKizMarkDTO>>(`${this._baseUrl}/${this._routePrefix}/view`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e)
        })
    }
}

export default KizMarkRequest